/* VIP Pass (prompt 83). Product page: early-access countdown, unlock at ssc.public_at, and a submit guard while the
   product is locked (the crew API's orders/create check is the real guard). /pages/vip: plan picker, Join (adds the
   plan's product with its Shopify Subscriptions selling plan, then checkout), member renewal line and the custom piece
   form (lists from /api/crew/me → vip; also sent as a Shopify contact form so the shop gets an email). */
(() => {
  if (window.sscVipLoaded) return;
  window.sscVipLoaded = true;
  const esc = (s) => String(s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const monthDay = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  // ---------- product page
  const pdp = document.querySelector('[data-ssc-pdp]');
  if (pdp) {
    pdp.addEventListener('submit', (event) => {
      if (pdp.hasAttribute('data-ssc-vip-lock')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    const gate = pdp.querySelector('[data-ssc-vip-gate][data-public-at]');
    const at = gate ? Number(gate.dataset.publicAt) * 1000 : 0;
    if (gate && at) {
      const opens = gate.querySelector('[data-ssc-vip-opens]');
      const when = new Date(at);
      const wd = when.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'America/New_York' });
      const hm = when.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }).replace(':00', '').replace(' ', '').toLowerCase();
      if (opens) opens.textContent = `Opens ${wd} ${hm} ET`;
      const unlock = () => {
        pdp.removeAttribute('data-ssc-vip-lock');
        pdp.querySelector('[data-ssc-vip-form]')?.removeAttribute('hidden');
        document.querySelector('[data-ssc-sticky]')?.removeAttribute('data-ssc-vip-locked');
        gate.remove();
      };
      const tick = () => {
        const left = at - Date.now();
        if (left <= 0) { unlock(); return false; }
        const m = Math.floor(left / 60000);
        const put = (k, n) => { const el = gate.querySelector(`[data-t="${k}"]`); if (el) el.textContent = String(n); };
        put('d', Math.floor(m / 1440));
        put('h', Math.floor((m % 1440) / 60));
        put('m', m % 60);
        return true;
      };
      if (tick()) {
        const id = setInterval(() => { if (!tick()) clearInterval(id); }, 30000);
      }
    }
  }

  // ---------- /pages/vip
  const page = document.querySelector('[data-ssc-vip-page]');
  if (!page) return;

  const plans = [...page.querySelectorAll('.ssc-vip__plan')];
  const join = page.querySelector('[data-ssc-vip-join]');
  const joinMsg = page.querySelector('[data-ssc-vip-join-msg]');
  const chosen = () => plans.find((b) => b.getAttribute('aria-pressed') === 'true') || plans[0];
  const paintJoin = () => {
    const p = chosen();
    if (!join || !p) return;
    const ready = !!(p.dataset.variant && p.dataset.sellingPlan);
    join.textContent = `Join VIP · ${p.dataset.label}`;
    join.disabled = !ready;
    if (joinMsg) {
      joinMsg.hidden = ready;
      joinMsg.textContent = ready ? '' : 'Joining opens soon.';
    }
  };
  plans.forEach((b) => b.addEventListener('click', () => {
    plans.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    paintJoin();
  }));
  paintJoin();
  join?.addEventListener('click', async () => {
    const p = chosen();
    if (!p || !p.dataset.variant || !p.dataset.sellingPlan) return;
    join.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(p.dataset.variant), quantity: 1, selling_plan: Number(p.dataset.sellingPlan) }] }),
      });
      if (!res.ok) throw new Error(String(res.status));
      window.location.href = '/checkout';
    } catch (e) {
      join.disabled = false;
      if (joinMsg) {
        joinMsg.hidden = false;
        joinMsg.textContent = "Couldn't start checkout. Try again.";
      }
    }
  });

  if (page.dataset.member !== 'true') return;

  const withCrew = (fn) => {
    if (window.sscCrew) fn(window.sscCrew);
    else document.addEventListener('ssc-crew:ready', () => fn(window.sscCrew), { once: true });
  };

  const form = page.querySelector('[data-ssc-vip-custom]');
  const state = form?.querySelector('[data-ssc-vip-custom-state]');
  const fields = form?.querySelector('[data-ssc-vip-fields]');
  const msg = form?.querySelector('[data-ssc-vip-custom-msg]');
  const say = (el, text) => { if (el) { el.textContent = text; el.hidden = !text; } };

  withCrew(async (crew) => {
    const d = crew.signed ? await crew.me() : null;
    const v = d && d.vip;
    if (v && v.member) {
      const renew = page.querySelector('[data-ssc-vip-renew]');
      const eyebrow = page.querySelector('[data-ssc-vip-eyebrow]');
      if (eyebrow) eyebrow.textContent = `VIP Pass · ${v.plan === 'yearly' ? 'yearly' : 'monthly'}`;
      if (renew && v.paid_through) renew.textContent = `Renews ${monthDay(v.paid_through)} · ${v.plan === 'yearly' ? '$99' : '$9.99'}. Manage or cancel in your account.`;
    }
    if (!form) return;
    if (!v || !v.member || !v.custom || !v.custom.allow) {
      say(state, "The request form can't load right now. Try again later.");
      return;
    }
    if (v.custom.left <= 0) {
      const r = v.custom.request;
      say(state, r ? `You sent this month's request: ${r.design} on ${r.product} (${r.size}). We'll reply within 2 days. Next one opens on the 1st.` : "You've used this month's request.");
      return;
    }
    const allow = v.custom.allow.products || [];
    const designs = v.custom.designs || [];
    const sel = (name) => form.querySelector(`select[name="${name}"]`);
    const byAnime = new Map();
    designs.forEach((x) => { if (!byAnime.has(x.anime)) byAnime.set(x.anime, []); byAnime.get(x.anime).push(x); });
    sel('design').innerHTML = '<option value="">Pick a design</option>' + [...byAnime.entries()].sort((a, b) => a[0].localeCompare(b[0]))
      .map(([anime, list]) => `<optgroup label="${esc(anime)}">${list.map((x) => `<option value="${esc(x.title)}" data-key="${esc(x.key)}">${esc(x.title)}</option>`).join('')}</optgroup>`).join('');
    sel('product').innerHTML = '<option value="">Pick a product</option>' + allow.map((p) => `<option>${esc(p.name)}</option>`).join('');
    const sizes = () => {
      const p = allow.find((x) => x.name === sel('product').value);
      const keep = sel('size').value;
      sel('size').innerHTML = '<option value="">Size</option>' + (p ? p.sizes.map((s) => `<option${s === keep ? ' selected' : ''}>${esc(s)}</option>`).join('') : '');
    };
    const ok = form.querySelector('[data-ssc-vip-ok]');
    const no = form.querySelector('[data-ssc-vip-no]');
    const check = () => {
      const p = allow.find((x) => x.name === sel('product').value);
      const opt = sel('design').selectedOptions[0];
      const key = opt && opt.dataset.key;
      let bad = '';
      if (p && key && p.designs !== '*' && !p.designs.includes(key)) bad = `${opt.value} can't go on ${p.name} yet.`;
      say(no, bad);
      say(ok, !bad && p && key && sel('size').value ? "This combo works. You pay the normal price, it's made to order and ships in 3–5 weeks." : '');
      return !bad && !!(p && key && sel('size').value);
    };
    sel('product').addEventListener('change', () => { sizes(); check(); });
    sel('design').addEventListener('change', check);
    sel('size').addEventListener('change', check);
    sizes();
    say(state, v.custom.allow.placeholder ? 'Our full list of products is coming soon. For now: shorts.' : '');
    fields.hidden = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!check()) { say(msg, 'Pick a design, a product and a size.'); return; }
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      const body = { design: sel('design').value, product: sel('product').value, size: sel('size').value, note: form.querySelector('textarea[name="note"]').value.trim() };
      const r = await crew.custom(body);
      if (!r || (r.status !== 'sent' && r.status !== 'already')) {
        button.disabled = false;
        say(msg, (r && r.message) || "Couldn't send it. Try again.");
        return;
      }
      if (r.status === 'sent') {
        // Email to the shop: the store's own contact form (no other tool).
        const f = new URLSearchParams();
        f.set('form_type', 'contact');
        f.set('utf8', '✓');
        f.set('contact[email]', page.dataset.email || '');
        f.set('contact[name]', page.dataset.name || '');
        f.set('contact[body]', `VIP custom piece request\nDesign: ${body.design}\nProduct: ${body.product}\nSize: ${body.size}\nNote: ${body.note || '-'}`);
        fetch('/contact', { method: 'POST', body: f, credentials: 'same-origin' }).catch(() => { /* the crew API has it anyway */ });
      }
      fields.hidden = true;
      say(state, '');
      say(msg, r.message || "Sent. We'll reply within 2 days.");
    });
  });
})();
